var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcEndCall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9973 8C8.06156 8 4.36218 8.82714 2.51703 10.6723C1.68081 11.5085 1.26269 12.5174 1.31723 13.7354C1.35359 14.4717 1.58082 15.1261 2.00802 15.5533C2.32615 15.8805 2.77153 16.0623 3.28963 15.9805L6.6618 15.4079C7.1708 15.3261 7.52529 15.1715 7.75252 14.9352C8.05248 14.6444 8.14337 14.2081 8.14337 13.6354V12.6478C8.14337 12.5023 8.20699 12.3933 8.29789 12.3024C8.38878 12.1933 8.52512 12.1478 8.62511 12.1206C9.24319 11.9751 10.4975 11.8388 11.9973 11.8388C13.497 11.8388 14.7423 11.9479 15.3694 12.1297C15.4603 12.1569 15.5876 12.2115 15.6876 12.3024C15.7694 12.3933 15.8239 12.4932 15.833 12.6387L15.8421 13.6354C15.8512 14.2081 15.9421 14.6444 16.2329 14.9352C16.4693 15.1715 16.8237 15.3261 17.3328 15.4079L20.6595 15.9714C21.1957 16.0623 21.6502 15.8714 22.0047 15.526C22.4319 15.1079 22.6682 14.4626 22.6864 13.7263C22.7137 12.4993 22.241 11.4903 21.423 10.6723C19.5778 8.82714 15.933 8 11.9973 8Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcEndCall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-end-call.8f36c224a9efd82fd01e62d7b2b1feec.svg";